<div class="elevator-wartungshistory-page">
  <div class="widgets-container">
    <div class="widgets-grid">
      @if (user.internalAccess) {
        <div class="cell-history">
          <wartungshistory-component [facilityNoInternal]="facilityNoInternal"></wartungshistory-component>
        </div>
      }
    </div>
  </div>
</div>